


































import {
  defineComponent,
  PropType,
  ref,
  computed
} from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';
import type { CategoryInterface } from '@wemade-vsf/magento-api';

export default defineComponent({
  name: 'CategoryDescription',
  props: {
    categoryMeta: {
      type: Object as PropType<CategoryInterface>,
      required: true
    },
    isShowCms: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CmsContent: () => import('components/theme/Content/CmsContent.vue'),
    CmsBlocks: () => import('components/theme/Content/CmsBlocks.vue'),
    SfButton
  },
  setup (props) {
    const hasMoreContent = computed(() => !!props.categoryMeta.additional_content)
    const displayAdditionalContent = ref(false);
    const cmsBlockIdentifier = props.categoryMeta.cms_block?.identifier || ''

    return {
      hasMoreContent,
      cmsBlockIdentifier,
      displayAdditionalContent
    }
  }
})
